// extracted by mini-css-extract-plugin
module.exports = {"rootArea":"AdministratingLeftSidebar_rootArea__2lT6J"};